var _rect, _rect2, _circle, _circle2, _circle3, _path, _polygon, _path2, _path3, _path4, _path5, _rect3, _path6, _rect4, _rect5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle4, _polygon2, _rect6, _rect7, _rect8, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path21, _path22, _polygon8, _rect18, _rect19, _rect20, _rect21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.19,
    y: 47.41,
    width: 299.38,
    height: 217.54,
    transform: "matrix(1, 0, 0, 1, -0.39, 0.49)",
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.91,
    y: 47.78,
    width: 299.49,
    height: 42.46,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.77,
    cy: 69.5,
    r: 5.43,
    fill: "#24285b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.91,
    cy: 69.46,
    r: 5.43,
    fill: "#68e1fd"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.13,
    cy: 69.42,
    r: 5.43,
    fill: "#ffd200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.31,118.58s3.48,6.35,4.31,11.23a3.63,3.63,0,0,1-3,4.19c-2.46.39-5.9.19-8.19-3l-4.53-4.92a6.49,6.49,0,0,1-.19-7.51C186.25,114.24,193.37,114.6,195.31,118.58Z",
    fill: "#f4a28c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "186.51 124.96 184.88 148.64 198 148.61 193.92 131.39 186.51 124.96",
    fill: "#f4a28c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.78,119.58a29.3,29.3,0,0,1-6.31,2.23,6,6,0,0,1,2.67,6.06,4.93,4.93,0,0,1-4.64,4.2l-3.65-8.57a7.4,7.4,0,0,1,.76-7.53,28.86,28.86,0,0,1,2.23-2.64c2-2.07,6.33-2,7.8-4.64a1.75,1.75,0,0,1,3-.07c1.53,2.42,2.86,6.7,0,9.66A6.46,6.46,0,0,1,193.78,119.58Z",
    fill: "#24285b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.76,127.36s-1.17-2.53-3-1.49-.16,4.71,2.6,3.91Z",
    fill: "#f4a28c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.3,122.69l3,1.74a1.16,1.16,0,0,1,.07,2L198,128Z",
    fill: "#f4a28c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195,135.12a8.58,8.58,0,0,1-4.45-2.14s.57,4.31,5.71,8.15Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 194.93,
    y: 61.14,
    width: 4.84,
    height: 14.97,
    fill: "#ffd200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.33,35.23h33.09a0,0,0,0,1,0,0v23a6.19,6.19,0,0,1-6.19,6.19H187.53a6.19,6.19,0,0,1-6.19-6.19v-23A0,0,0,0,1,181.33,35.23Z",
    transform: "translate(2 -7.37) rotate(2.14)",
    fill: "#ffd200"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 189.07,
    y: 72.3,
    width: 17.44,
    height: 13.17,
    fill: "#24285b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 193.12,
    y: 75.35,
    width: 9.35,
    height: 7.06,
    fill: "#fff",
    opacity: 0.13
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.56,57.12H179.63a9.14,9.14,0,0,1,0-18.28h15.93ZM179.63,41a6.95,6.95,0,1,0,0,13.9h13.74V41Z",
    fill: "#ffd200"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.11,57.12H202.19V38.84h15.92a9.14,9.14,0,0,1,0,18.28Zm-13.74-2.19h13.74a7,7,0,1,0,0-13.9H204.37Z",
    fill: "#ffd200"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.37,40.63c-.65,4.81-1.09,15.12,6.13,19.21a1,1,0,0,0,1.42-1.4c-1.84-3.12-4-9-2.4-17.71a2.24,2.24,0,0,0-2.21-2.65h0A3,3,0,0,0,185.37,40.63Z",
    fill: "#fff",
    opacity: 0.43
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.14,80l3.72,8.63c-2.74.32-39.41,21.77-38.1,40.68s41.64,27,26.58,53.87-45.25-20.56-47.54-35.62S118.63,100.16,182.14,80Z",
    fill: "#68e1fd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.86,88.6c2.75-.33,7.4-5.57,3.07-12.15S182.14,80,182.14,80,185.13,88.69,185.86,88.6Z",
    fill: "#f4a28c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M212.17,81.61l-3.72,8.62c2.74.33,39.41,21.77,38.1,40.68s-40.62,23.86-25.56,50.7,44.22-17.39,46.52-32.45S275.68,101.79,212.17,81.61Z",
    fill: "#68e1fd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.14,80l3.72,8.63c-2.74.32-39.41,21.77-38.1,40.68s41.64,27,26.58,53.87-45.25-20.56-47.54-35.62S118.63,100.16,182.14,80Z",
    fill: "#fff",
    opacity: 0.46
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.17,81.61l-3.72,8.62c2.74.33,39.41,21.77,38.1,40.68s-40.62,23.86-25.56,50.7,44.22-17.39,46.52-32.45S275.68,101.79,212.17,81.61Z",
    fill: "#fff",
    opacity: 0.46
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M212.17,81.61s-2.46-10.11-6.79-3.53.32,11.82,3.07,12.15Z",
    fill: "#f4a28c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184.88,148.64l13.12,0s46.07,1.2,42.6,37.87-23.11,67.45-23.11,67.45l-47.29-2.7S118.87,150.09,184.88,148.64Z",
    fill: "#68e1fd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.28,142.91s-10.68,4.61-6.42,18.36,14.2,26.57,14.2,26.57l4.24-1.48s-19.93-27.26-12.42-37.72Z",
    fill: "#24285b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M196.58,142.62s9,1.51,7,18.65a112,112,0,0,1-6.23,25.7l-4.4-.22s6.75-21.81,4.61-38.11Z",
    fill: "#24285b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M187.67,198.62l-2.95,22.76,3.87-4.86s4.28,7.82,4.16,7.29,2.39-23.28,2.39-23.28Z",
    opacity: 0.09
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.64,198.62l3,22.76-3.86-4.86s-4.29,7.82-4.16,7.29-2.4-23.28-2.4-23.28Z",
    opacity: 0.09
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.49,
    cy: 192.81,
    r: 12.02,
    fill: "#ffd200"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "220.08 265.38 217.49 253.93 170.2 251.23 168.91 265.38 220.08 265.38",
    fill: "#24285b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.47,
    y: 214.95,
    width: 80.81,
    height: 30.15,
    fill: "#666",
    opacity: 0.08
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.48,
    y: 209.58,
    width: 77.57,
    height: 30.15,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.15,
    y: 209.52,
    width: 90.24,
    height: 30.15,
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "52.49 217.13 54.51 221.21 59.01 221.86 55.75 225.04 56.52 229.53 52.49 227.41 48.46 229.53 49.23 225.04 45.97 221.86 50.48 221.21 52.49 217.13",
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "66.88 217.13 68.89 221.21 73.4 221.86 70.14 225.04 70.91 229.53 66.88 227.41 62.85 229.53 63.62 225.04 60.36 221.86 64.86 221.21 66.88 217.13",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "81.27 217.13 83.28 221.21 87.79 221.86 84.53 225.04 85.3 229.53 81.27 227.41 77.24 229.53 78.01 225.04 74.75 221.86 79.25 221.21 81.27 217.13",
    fill: "#fff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.65 217.13 97.67 221.21 102.17 221.86 98.92 225.04 99.68 229.53 95.65 227.41 91.63 229.53 92.39 225.04 89.13 221.86 93.64 221.21 95.65 217.13",
    fill: "#fff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.04 217.13 112.06 221.21 116.56 221.86 113.3 225.04 114.07 229.53 110.04 227.41 106.01 229.53 106.78 225.04 103.52 221.86 108.03 221.21 110.04 217.13",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 257.82,
    y: 195.3,
    width: 45.7,
    height: 5.57,
    fill: "#ccc"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 310.8,
    y: 195.3,
    width: 22.98,
    height: 5.57,
    fill: "#ccc"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 243.65,
    y: 210.1,
    width: 26.55,
    height: 5.57,
    fill: "#ccc",
    opacity: 0.8
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 278.12,
    y: 210.1,
    width: 55.66,
    height: 5.57,
    fill: "#ccc",
    opacity: 0.8
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 243.65,
    y: 224.89,
    width: 90.13,
    height: 5.57,
    fill: "#ccc",
    opacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 243.65,
    y: 239.69,
    width: 62.68,
    height: 5.57,
    fill: "#ccc",
    opacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 65.19,
    y: 153.45,
    width: 13.14,
    height: 33.52,
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 84.31,
    y: 138.11,
    width: 13.14,
    height: 48.86,
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 103.43,
    y: 119.94,
    width: 13.14,
    height: 67.04,
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M332.39,108.73v75.13H311.63V134.63a63.53,63.53,0,0,1-9.75,6.2,75.76,75.76,0,0,1-11.81,4.53V128.53q10.47-3.37,16.27-8.11a33,33,0,0,0,9.07-11.69Z",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M293.86,175.77l.62-3.1h-3v-3.38h3.66l.88-4.38h3.48l-.89,4.38h2.69l.88-4.38h3.46l-.87,4.38h1.69v3.38h-2.37l-.62,3.1h3v3.38h-3.66l-.86,4.3h-3.48l.86-4.3h-2.7l-.87,4.3h-3.45l.86-4.3H291.5v-3.38Zm3.47,0H300l.62-3.1H298Z",
    fill: "#e6e6e6"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "110 102.59 112.15 106.96 116.97 107.66 113.48 111.06 114.31 115.86 110 113.59 105.68 115.86 106.51 111.06 103.02 107.66 107.84 106.96 110 102.59",
    fill: "#ffd200"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 68.42,
    y: 101.51,
    width: 15.89,
    height: 3.36,
    fill: "#ccc",
    opacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 68.42,
    y: 111.82,
    width: 15.89,
    height: 3.36,
    fill: "#ccc",
    opacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 87.49,
    y: 101.51,
    width: 4.12,
    height: 3.36,
    fill: "#ccc",
    opacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 87.49,
    y: 111.82,
    width: 4.12,
    height: 3.36,
    fill: "#ccc",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.1c40f48c.svg";
export { ForwardRef as ReactComponent };